import Vue from 'vue'
import MessageBoxOwn from '../widget/MessageBoxOwn.vue'
import merge from 'element-ui/src/utils/merge'
import { isVNode } from 'element-ui/src/utils/vdom'
const defaults = {
    title: undefined,
    content: ''
}
let instance, currentMsg
let msgQueue = []
const MsgBoxOwnConstructor = Vue.extend(MessageBoxOwn)

const defaultCallback = action => {
    // debugger;
    if (currentMsg) {
        let callback = currentMsg.callback
        if (typeof callback === 'function') {
            if (instance.showInput) {
                callback(instance.inputValue, action)
            } else {
                callback(action)
            }
        }
        if (currentMsg.resolve) {
            if (action === 'sure') {
                if (instance.showInput) {
                    currentMsg.resolve({ value: instance.inputValue, action })
                } else {
                    currentMsg.resolve(action)
                }
            } else if (action === 'cancel' && currentMsg.reject) {
                currentMsg.reject(action)
            }
        }
    }
}

const initInstance = () => {
    // debugger;
    instance = new MsgBoxOwnConstructor({
        el: document.createElement('div')
    })
    instance.callback = defaultCallback
}

const showNextMsg = () => {
    // debugger;
    if (!instance) {
        initInstance()
    }
    instance.action = ''

    if (!instance.visible || instance.closeTimer) {
        if (msgQueue.length > 0) {
            currentMsg = msgQueue.shift()

            let options = currentMsg.options
            for (let prop in options) {
                if (options.hasOwnProperty(prop)) {
                    instance[prop] = options[prop]
                }
            }
            if (options.callback === undefined) {
                instance.callback = defaultCallback
            }

            let oldCb = instance.callback
            instance.callback = (action, instance) => {
                oldCb(action, instance)
                showNextMsg()
            }
            if (isVNode(instance.message)) {
                instance.$slots.default = [instance.message]
                instance.message = null
            } else {
                delete instance.$slots.default
            }
            ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape'].forEach(
                prop => {
                    if (instance[prop] === undefined) {
                        instance[prop] = true
                    }
                }
            )
            document.body.appendChild(instance.$el)

            Vue.nextTick(() => {
                instance.visible = true
            })
        }
    }
}

const MsgBoxOwn = function(options, callback) {
    // debugger;
    if (Vue.prototype.$isServer) return
    if (typeof options === 'string') {
        options = {
            message: options
        }
        if (arguments[1]) {
            options.title = arguments[1]
        }
        if (arguments[2]) {
            options.type = arguments[2]
        }
    } else if (options.callback && !callback) {
        callback = options.callback
    }

    if (typeof Promise !== 'undefined') {
        return new Promise((resolve, reject) => {
      // eslint-disable-line
            msgQueue.push({
                options: merge({}, defaults, MsgBoxOwn.defaults, options),
                callback: callback,
                resolve: resolve,
                reject: reject
            })

            showNextMsg()
        })
    } else {
        msgQueue.push({
            options: merge({}, defaults, MsgBoxOwn.defaults, options),
            callback: callback
        })

        showNextMsg()
    }
}

MsgBoxOwn.setDefaults = defaults => {
    MsgBoxOwn.defaults = defaults
}

MsgBoxOwn.qttConfirmShortCut = (message, title, options) => {
    //   debugger;
    if (typeof title === 'object') {
        options = title
        title = ''
    } else if (title === undefined) {
        title = ''
    }
    return MsgBoxOwn({
        ...message,
        title: title
    })
}

MsgBoxOwn.qttConfirmShortCut.close = () => {
    //   debugger;
    instance.closePanel()
    instance.visible = false
}

MsgBoxOwn.install = function(Vue, options) {
    Vue.prototype.$msgBoxOwn = MsgBoxOwn.qttConfirmShortCut
}

export default MsgBoxOwn
export { MsgBoxOwn }



// WEBPACK FOOTER //
// ./src/common/js/MessageBoxOwn.js